import { Health } from 'iconsax-react';

import IntlMessages from '../../layout/components/lang/IntlMessages';

const main = [
  {
    id: 'rents-dashboard',
    title: <IntlMessages id='dashboard' />,
    navLink: '/apps/cockpit/rents-dashboard',
    icon: <Health size={18} />,
    requires: 'dashboard:read',
    else: {
      id: 'home-page',
      title: 'Página Incial',
      navLink: '/',
      icon: <Health size={18} />,
    },
  },
];

export default main;
